module.exports = __webpack_public_path__ + "static/img/curstage_0.fbc5aa8e.png";